import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  PUBLISHERS: {
    GET: undefined,
    API: {
      GET: apiResourceActionCreator('publishers')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}`, authToken, actions.publishers.api.get)

export function* getPublishers() {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: getPublishers,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        publishers: [],
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        publishers: action.payload.publishers,
        error: null
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload.error
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/publisher/configurations/get.js